export const TrackingInfo = {
  dataCategory: "My Account Area",
  dataAction: "click",
  dataLabel: ""
};
